import * as React from 'react';

interface IState {
  time: string;
}

interface IProps {
  localStartTime: Date;
  serverDuration: number;
}

export default class Timer extends React.Component<IProps, IState> {
  timer?: NodeJS.Timer;

  constructor(props: IProps) {
    super(props);
    this.state = {
      time: ''
    };
  }

  componentWillMount() {
    this.timer = setInterval(this.updateTime, 1000);
    this.updateTime();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  componentDidUpdate() {
    this.updateTime();
  }

  render() {
    const { time } = this.state;
    return (
      <span
        style={{
          fontFamily: 'Courier New, Courier, fixed',
          fontSize: '200%',
          color: 'red',
          textAlign: 'center',
          fontWeight: 'bold'
        }}
      >
        {time}
      </span>
    );
  }

  updateTime = () => {
    const { serverDuration, localStartTime } = this.props;
    const now = new Date();
    const localDuration = (now.getTime() - localStartTime.getTime()) / 1000;
    const duration = serverDuration + localDuration;
    const strDuration = toStringDuration(duration);
    const { time } = this.state;
    if (time !== strDuration) {
      this.setState({
        time: strDuration
      });
    }
  };
}

function toStringDuration(duration: number) {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration - hours * 3600) / 60);
  const seconds = Math.floor(duration - hours * 3600 - minutes * 60);
  return (
    leadingZeros(hours, 2) +
    ':' +
    leadingZeros(minutes, 2) +
    ':' +
    leadingZeros(seconds, 2)
  );
}

function leadingZeros(val: number, size: number) {
  let s = String(val);
  while (s.length < (size || 2)) {
    s = '0' + s;
  }
  return s;
}



// WEBPACK FOOTER //
// ./src/components/Timer.tsx